import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";
import { QUERY_STATUS } from "constants/constants";
import {
  getExternalTrainingByUserIdQuery,
  uploadExternalTrainingByuserIdQuery,
} from "./queries";
import { useUserContext } from "api/user/UserProvider";
import { fixUTF8InObject } from "utils/encodingHelper";

const ExternalTrainingContext = createContext({});

export const useExternalTrainingContext = () =>
  useContext(ExternalTrainingContext);

export const ExternalTrainingProvider = ({ ...props }) => {
  const { userScope } = useUserContext();
  const [externalTraining, setExternalTraining] = useState([]);
  const [uploadExternalTrainingStatus, setUploadExternalTrainingStatus] =
    useState(QUERY_STATUS.INITIAL);
  const [progression, setProgression] = useState(0);
  const [serverResponse, setServerResponse] = useState({});

  const getExternalTrainingByUserId = useCallback(
    async ({ id }) => {
      try {
        const result = await getExternalTrainingByUserIdQuery({
          id,
          userScope,
        });
        const fixedResult = fixUTF8InObject(result);
        setExternalTraining(fixedResult);
      } catch (e) {
        console.error("getExternalTrainingByUserId", e);
        throw e;
      }
    },
    [userScope]
  );

  const uploadExternalTrainingByUserId = useCallback(
    async ({ data }) => {
      if (data) {
        setUploadExternalTrainingStatus(QUERY_STATUS.LOADING);
        try {
          const result = await uploadExternalTrainingByuserIdQuery({
            data,
            setProgression,
            userScope,
          });
          setServerResponse(result);
          setUploadExternalTrainingStatus(QUERY_STATUS.SUCCESS);
        } catch (e) {
          console.error("uploadExternalTrainingByUserId", e);
          setServerResponse(e.message);
          setUploadExternalTrainingStatus(QUERY_STATUS.ERROR);
        }
      }
    },
    [userScope]
  );

  const values = useMemo(
    () => ({
      externalTraining,
      setExternalTraining,
      getExternalTrainingByUserId,
      uploadExternalTrainingByUserId,
      uploadExternalTrainingStatus,
      setUploadExternalTrainingStatus,
      progression,
      setProgression,
      serverResponse,
      setServerResponse,
    }),
    [
      externalTraining,
      setExternalTraining,
      getExternalTrainingByUserId,
      uploadExternalTrainingByUserId,
      uploadExternalTrainingStatus,
      setUploadExternalTrainingStatus,
      progression,
      setProgression,
      serverResponse,
      setServerResponse,
    ]
  );

  return <ExternalTrainingContext.Provider value={values} {...props} />;
};
